export const getPackageColumnDefinitions = () => {
    const style = { height: 34, padding: '0 11px' };

    return [
        {
            displayOrder: 1,
            headerName: '',
            field: 'id',
            type: 'rowId',
            hideInColumnFilter: true
        },

        {
            displayOrder: 4,
            headerName: window.translate('Name'),
            field: 'name',
            type: 'text',

            width: 'auto',
            hideInColumnFilter: true,
            showInList: true,
            sortable: false,
            sortOrder: '',
            style: {
                ...style,
                borderLeft: '1px solid rgb(215, 215, 215)'
            }
        },
        {
            displayOrder: 5,
            headerName: window.translate('Description'),
            field: 'description',
            type: 'text',

            width: 'auto',
            hideInColumnFilter: false,
            showInList: true,
            sortable: false,
            sortOrder: '',
            style
        },
        {
            displayOrder: 5,
            headerName: window.translate('Spots Per Week'),
            field: 'spotsOneWeek',
            type: 'number',

            width: 'auto',
            hideInColumnFilter: false,
            showInList: true,
            sortable: false,
            sortOrder: '',
            style
        },
        {
            displayOrder: 5,
            headerName: window.translate('One week Price'),
            field: 'recommendedPriceOneWeek',
            type: 'currency',

            width: 'auto',
            hideInColumnFilter: false,
            showInList: true,
            sortable: false,
            sortOrder: '',
            style
        },
        {
            displayOrder: 5,
            headerName: window.translate('One week Impacts'),
            field: 'impactsOneWeek',
            type: 'number',

            width: 'auto',
            hideInColumnFilter: false,
            showInList: true,
            sortable: false,
            sortOrder: '',
            style
        }
    ];
};
